'use client';

import * as React from 'react';
import type { Action, State } from './video-context';
import { VideoContext } from './video-context';

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'PLAY_VIDEO':
      return {
        ...state,
        status: 'PLAYING',
      };
    case 'MUTE_VIDEO':
      return {
        ...state,
        status: 'MUTED',
      };
    default:
      return state;
  }
};

const initialContext: State = {
  status: 'MUTED',
};

export function VideoProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = React.useReducer(reducer, initialContext);

  const value: VideoContext = React.useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state, dispatch],
  );

  return (
    <VideoContext.Provider value={value}>{children}</VideoContext.Provider>
  );
}
